import { type FormikErrors, type FormikTouched } from "formik";

export const fieldErrorCreator =
    <V, K extends keyof V>(errors: FormikErrors<V>, touched: FormikTouched<V>) =>
    (key: K): FormikErrors<V>[K] => {
        return touched[key] && errors[key];
    };

export type MakeFieldErrorFunction<V, K extends keyof V> = (key: K) => FormikErrors<V>[K];
